import UIIconButton from 'components/UI/IconButton/IconButton';
import nielsen_old_logo from 'components/assets/img/nielsen_old_logo.png';
import UIIcon from 'components/UI/Icon/Icon';
import { ImageTooltip } from 'components/UI/ImageTooltip/ImageTooltip';
import type { ExtendedViewership } from '../types';

export const getInfoCellRenderer = (
  { data }: { data: ExtendedViewership },
  onEditManualViewership: (id: string) => void,
  enableManualMetricButtons: boolean,
) => {
  // Check if we are on the last row
  if (
    data.rowIndex === 0 &&
    !data.isSecondaryViewership &&
    !data.isPrimaryViewership
  ) {
    return null;
  }
  if (!data?.provider) {
    return <div />;
  }
  return (
    <>
      {data?.provider?.toUpperCase() === 'MANUAL' && enableManualMetricButtons && (
        <div className="manual__edit-button__wrapper">
          <UIIconButton
            icon="mode_edit"
            className="manual__edit-button"
            tooltip="Manual Provider"
            onClick={() => {
              const {
                isSecondaryViewership,
                isPrimaryViewership,
                info,
                ...viewershipData
              } = data;
              onEditManualViewership(viewershipData.id);
            }}
            size="small"
          />
        </div>
      )}
      {data?.provider?.toUpperCase() === 'VDS' && (
        <ImageTooltip
          tooltip="Nielsen"
          className="legacy__logo"
          src={nielsen_old_logo}
        />
      )}
      {data?.provider?.toUpperCase() === 'MDE' && (
        <ImageTooltip tooltip="MDE - Nielsen" src={nielsen_old_logo} />
      )}
      <UIIcon type="info_outline" size="small" tooltip={data.info} />
    </>
  );
};
